import React, { FC } from "react";

import { toast } from "react-toastify";

import {
  useApisManagersBusinessDivisionsArchivedsCreate,
  useSearchManagersBusinessDivisions,
} from "~/hooks";

import {
  FormSubmitButton,
  Form,
  Button,
  GridHeaderCells,
} from "~/components/atoms";
import {
  EmployeeLayout,
  EmployeeLayoutMainContent,
} from "~/components/layouts";
import {
  GridRow,
  OpenedMenuInGrid,
  LabelWithTextField,
  LabelWithMultipleDropdownField,
  InfiniteScrollWithMoreButton,
} from "~/components/molecules";
import { FilterWrapper, GridContainer } from "~/components/organisms";

import { BusinessDivisionType } from "~/domains";

export const ManagersBusinessDivisionsIndex: FC = () => {
  const {
    businessDivisions,
    hasNextPage,
    isLoading,
    selectableDropdownBusinessDivisions,
    selectedDropdownBusinessDivisions,
    keyword,
    fetchNextPage,
    onChangeDropdownBusinessDivisions,
    findAndRemove,
    onChangeKeyword,
    onConditionReset,
    onSearchSubmit,
  } = useSearchManagersBusinessDivisions();

  const { mutate: archivedRequest } =
    useApisManagersBusinessDivisionsArchivedsCreate();

  const handleDelete = (targetBusinessDivision: BusinessDivisionType) => {
    const isConfirm = confirm("本当に無効にしますか？");
    if (!isConfirm) return;
    archivedRequest(
      {
        businessDivisionId: targetBusinessDivision.id,
      },
      {
        onSuccess: (data) => {
          toast(data.message);
          findAndRemove((item) => item.id === targetBusinessDivision.id);
        },
      },
    );
  };

  const breadCrumbItems = [
    { label: "部署設定", href: "/managers/business_divisions" },
    { label: "一覧", href: "/managers/business_divisions" },
  ];

  return (
    <>
      <EmployeeLayout
        withRightSidebar={false}
        breadCrumbItems={breadCrumbItems}
      >
        <EmployeeLayoutMainContent withRightSidebar={false}>
          <FilterWrapper title="部署検索">
            <Form onSubmit={onSearchSubmit} className="space-y-4">
              <>
                <div className="grid miniTablet:grid-cols-2 gap-4">
                  <LabelWithMultipleDropdownField
                    labelText="部署"
                    name="businessDivisionIds"
                    options={selectableDropdownBusinessDivisions}
                    value={selectedDropdownBusinessDivisions}
                    placeholder="選択してください"
                    onChange={onChangeDropdownBusinessDivisions}
                  />
                  <LabelWithTextField
                    labelText="フリーワード"
                    type="text"
                    name="keyword"
                    placeholder="部署名検索"
                    value={keyword}
                    onChange={onChangeKeyword}
                  />
                </div>
                <div className="flex items-center justify-end space-x-4">
                  <Button
                    color="gray"
                    outline
                    className="w-full miniTablet:w-auto"
                    text="リセット"
                    onClick={onConditionReset}
                  />
                  <FormSubmitButton
                    value="検索する"
                    color="primary"
                    className="w-full miniTablet:w-auto"
                  />
                </div>
              </>
            </Form>
          </FilterWrapper>
          <InfiniteScrollWithMoreButton
            itemsLength={businessDivisions.length}
            nextFetchFunction={fetchNextPage}
            isLoading={isLoading}
            hasMore={hasNextPage}
            className="mt-12"
          >
            <GridContainer cols={1}>
              <GridHeaderCells texts={["部署"]} />
              <>
                {businessDivisions.map((businessDivision) => (
                  <GridRow
                    key={businessDivision.id}
                    lists={[businessDivision.name]}
                    openedMenu={
                      <OpenedMenuInGrid
                        cols={1}
                        buttons={[
                          {
                            text: "編集",
                            link: `/managers/business_divisions/${businessDivision.id}/edit`,
                          },
                          {
                            text: "無効化",
                            onClick: () => handleDelete(businessDivision),
                          },
                        ]}
                      />
                    }
                  />
                ))}
              </>
            </GridContainer>
          </InfiniteScrollWithMoreButton>
        </EmployeeLayoutMainContent>
      </EmployeeLayout>
    </>
  );
};
